import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/react';
import { findDomRefAtPos } from 'prosemirror-utils';
import { injectIntl } from 'react-intl-next';
import { Popup } from '@atlaskit/editor-common/ui';
import { akEditorFloatingOverlapPanelZIndex, akEditorSmallZIndex } from '@atlaskit/editor-shared-styles';
import ExpandIcon from '@atlaskit/icon/glyph/chevron-down';
import { ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import { closestElement } from '@atlaskit/editor-common/utils';
import { toggleContextualMenu } from '../../commands';
import { TableCssClassName as ClassName } from '../../types';
import messages from '../../ui/messages';
import { CONTENT_COMPONENT } from '@atlaskit/editor-common/analytics';
import { ACTION, ACTION_SUBJECT, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { tableFloatingCellButtonStyles, tableFloatingCellButtonSelectedStyles } from './styles';
import { ErrorBoundary } from '@atlaskit/editor-common/error-boundary';
export var FloatingContextualButtonInner = /*#__PURE__*/function (_React$Component) {
  _inherits(FloatingContextualButtonInner, _React$Component);
  var _super = _createSuper(FloatingContextualButtonInner);
  function FloatingContextualButtonInner() {
    var _this;
    _classCallCheck(this, FloatingContextualButtonInner);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      var _this$props$editorVie = _this.props.editorView,
        state = _this$props$editorVie.state,
        dispatch = _this$props$editorVie.dispatch;
      // Clicking outside the dropdown handles toggling the menu closed
      // (otherwise these two toggles combat each other).
      // In the event a user clicks the chevron button again
      // That will count as clicking outside the dropdown and
      // will be toggled appropriately
      if (!_this.props.isContextualMenuOpen) {
        toggleContextualMenu()(state, dispatch);
      }
    });
    return _this;
  }
  _createClass(FloatingContextualButtonInner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        mountPoint = _this$props.mountPoint,
        scrollableElement = _this$props.scrollableElement,
        editorView = _this$props.editorView,
        targetCellPosition = _this$props.targetCellPosition,
        isContextualMenuOpen = _this$props.isContextualMenuOpen,
        formatMessage = _this$props.intl.formatMessage,
        dispatchAnalyticsEvent = _this$props.dispatchAnalyticsEvent; //  : Props & WrappedComponentProps
      var domAtPos = editorView.domAtPos.bind(editorView);
      var targetCellRef;
      try {
        targetCellRef = findDomRefAtPos(targetCellPosition, domAtPos);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        if (dispatchAnalyticsEvent) {
          var payload = {
            action: ACTION.ERRORED,
            actionSubject: ACTION_SUBJECT.CONTENT_COMPONENT,
            eventType: EVENT_TYPE.OPERATIONAL,
            attributes: {
              component: CONTENT_COMPONENT.FLOATING_CONTEXTUAL_BUTTON,
              selection: editorView.state.selection.toJSON(),
              position: targetCellPosition,
              docSize: editorView.state.doc.nodeSize,
              error: error instanceof Error ? error.message : String(error)
            },
            nonPrivacySafeAttributes: {
              errorStack: error instanceof Error ? error.stack : undefined
            }
          };
          dispatchAnalyticsEvent(payload);
        }
      }
      if (!targetCellRef || !(targetCellRef instanceof HTMLElement)) {
        return null;
      }
      var tableWrapper = closestElement(targetCellRef, ".".concat(ClassName.TABLE_NODE_WRAPPER));
      var labelCellOptions = formatMessage(messages.cellOptions);
      var button = jsx("div", {
        css: function css(theme) {
          return [tableFloatingCellButtonStyles({
            theme: theme
          }), isContextualMenuOpen && tableFloatingCellButtonSelectedStyles({
            theme: theme
          })];
        }
      }, jsx(ToolbarButton, {
        className: ClassName.CONTEXTUAL_MENU_BUTTON,
        selected: isContextualMenuOpen,
        title: labelCellOptions,
        onClick: this.handleClick,
        iconBefore: jsx(ExpandIcon, {
          label: ""
        }),
        "aria-label": labelCellOptions
      }));
      var parentSticky = targetCellRef.parentElement && targetCellRef.parentElement.className.indexOf('sticky') > -1;
      if (this.props.stickyHeader && parentSticky) {
        var pos = targetCellRef.getBoundingClientRect();
        return jsx("div", {
          style: {
            position: 'fixed',
            top: this.props.stickyHeader.top + this.props.stickyHeader.padding + 3 + 3,
            zIndex: akEditorFloatingOverlapPanelZIndex,
            left: pos.left + targetCellRef.clientWidth - 20 - 3
          }
        }, button);
      }
      return jsx(Popup, {
        alignX: "right",
        alignY: "start",
        target: targetCellRef,
        mountTo: tableWrapper || mountPoint,
        boundariesElement: targetCellRef,
        scrollableElement: scrollableElement,
        offset: [3, -3],
        forcePlacement: true,
        allowOutOfBounds: true,
        zIndex: akEditorSmallZIndex
      }, button);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.tableNode !== nextProps.tableNode || this.props.targetCellPosition !== nextProps.targetCellPosition || this.props.layout !== nextProps.layout || this.props.isContextualMenuOpen !== nextProps.isContextualMenuOpen || this.props.isNumberColumnEnabled !== nextProps.isNumberColumnEnabled || this.props.stickyHeader !== nextProps.stickyHeader;
    }
  }]);
  return FloatingContextualButtonInner;
}(React.Component);
_defineProperty(FloatingContextualButtonInner, "displayName", 'FloatingContextualButton');
var FloatingContextualButton = injectIntl(FloatingContextualButtonInner);
export default function (props) {
  return jsx(ErrorBoundary, {
    component: ACTION_SUBJECT.FLOATING_CONTEXTUAL_BUTTON,
    dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
    fallbackComponent: null
  }, jsx(FloatingContextualButton, props));
}